import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { COLORS } from './../../../styles/constants';
import { useSelector } from 'react-redux';

function Output({ screenWidth, ...props }) {
	const { values } = props.formikProps;
	const appliedStateOfQuickFilter = useSelector(state => state.filters.appliedState);
	const outputCurrentState = appliedStateOfQuickFilter.io.value;
	const outputVoltageState = appliedStateOfQuickFilter.voapo.value;
	const min = useSelector(state => state.filters.filters[2].constraints.minValue);
	const max = useSelector(state => state.filters.filters[2].constraints.maxValue);
	const isVoutInvalid = min && max ? outputVoltageState < min || outputVoltageState > max : false;

	return (
		<Grid>
			<Grid
				style={{
					marginBottom: '39px'
				}}></Grid>
			<Grid>
				<label htmlFor="Output__voltage">
					<span>
						<span>
							V<sub>OUT</sub>:{' '}
						</span>
						{appliedStateOfQuickFilter.voapo.used === true && !isVoutInvalid ? (
							<span>
								<span
									style={{
										color: COLORS.SECONDARY,
										fontWeight: 'bold'
									}}>
									{(values.vout = outputVoltageState)}
								</span>
								<span
									style={{
										color: COLORS.TEXT_SECONDARY
									}}>
									{' '}
									[V]
								</span>
							</span>
						) : (
							<span
								style={{
									color: COLORS.SECONDARY,
									fontWeight: 'bold'
								}}>
								{'\u00a0' + '\u2014'}
							</span>
						)}
					</span>
				</label>
				<div
					style={{
						color: COLORS.TEXT_SECONDARY,
						fontSize: '11px',
						paddingBottom: '23px'
					}}></div>
			</Grid>

			<Grid>
				<label htmlFor="Output__current">
					<span>
						<span>
							I<sub>OUT</sub>:{' '}
						</span>
						{appliedStateOfQuickFilter.io.isDirty === true ? (
							<span>
								<span
									style={{
										color: COLORS.SECONDARY,
										fontWeight: 'bold'
									}}>
									{(values.iout = outputCurrentState)}
								</span>
								<span
									style={{
										color: COLORS.TEXT_SECONDARY
									}}>
									{' '}
									[A]
								</span>
							</span>
						) : (
							<span
								style={{
									color: COLORS.SECONDARY,
									fontWeight: 'bold'
								}}>
								{'\u00a0' + '\u2014'}
							</span>
						)}
					</span>
				</label>
				<div
					style={{
						color: COLORS.TEXT_SECONDARY,
						fontSize: '11px',
						paddingBottom: '23px'
					}}></div>
			</Grid>
		</Grid>
	);
}

Output.propTypes = {
	screenWidth: PropTypes.number.isRequired
};

export default Output;
